module.exports = __webpack_public_path__ + "img/thumbfield1.3083abf4.png";